import React, {useState} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {FrontEvent} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemCheckbox} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemCheckbox';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {
  AsyncSearchDropdown,
  AsyncSearchDropdownDataFetcher,
} from '../../../../../libs/shared/ui/src/components/dropdowns/search/asyncSearchDropdown';
import {LensModel} from '../../../../models/api/lensModel';
import {ToggleDropdownLensHandler, workspacesEditorDropdownWidth} from '../editor/context/types';

/*
 * Props.
 */

interface WorkspaceEditorLensesDropdownProps extends DropdownProps {
  displayedLensesIds: ReadonlyArray<number>;
  toggleLens: ToggleDropdownLensHandler;
  fetchLensesAsync: AsyncSearchDropdownDataFetcher<LensModel, any>;
}

/*
 * Component.
 */

export const WorkspaceEditorLensesDropdown: React.FC<WorkspaceEditorLensesDropdownProps> = (props) => {
  const {displayedLensesIds, toggleLens, fetchLensesAsync} = props;
  const [query, setQuery] = useState('');

  const isLensChecked = (lens: LensModel) => displayedLensesIds.includes(lens.id);

  const renderRow = (lens: LensModel, index: number) => {
    const isChecked = isLensChecked(lens);
    const onLensSelect = (e: FrontEvent) => {
      e.preventDefault(); // Keep the dropdown open
      toggleLens(lens);
    };

    return (
      <DropdownItem
        index={index}
        onSelect={onLensSelect}
        renderRightContent={() => <DropdownItemCheckbox isChecked={isChecked} />}
      >
        <DropdownItemContent isChecked={isChecked}>{lens.name}</DropdownItemContent>
      </DropdownItem>
    );
  };

  return (
    <AsyncSearchDropdown
      {...props}
      interactionId="workspace-lenses-dropdown"
      headerTitle={<Trans id="workspace-lenses-dropdown-title">Shared views</Trans>}
      query={query}
      onQueryChange={(newQuery) => setQuery(newQuery)}
      width={workspacesEditorDropdownWidth}
      onRequestData={fetchLensesAsync}
      renderRow={renderRow}
    />
  );
};
